import React from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Stack,
  Typography,
  Card,
  CardHeader,
  CardContent,
  Checkbox,
  Grid,
  Button
} from '@mui/material';
import { useMutation } from 'react-fetching-library';
import { GridToolbar, plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import SendMessagePreviewModal from './SendMessagePreviewModal';
import { formatDateTime } from '../../../../../../services/functions';
import { sendOrderMail } from '../../../../../../services/request';
import toast from 'react-hot-toast';
import { EmailButton } from './EmailButton';


const Noitfications = ({ formik }) => {
  const { order } = useSelector(state => state.orderData);
  const { module } = useSelector(state => state.app);
  const { mutate: sendMailMutate } = useMutation(sendOrderMail);

  const columns = [
    {
      field: 'created_at',
      headerName: 'Data',
      flex: 0.4,
      valueGetter: params => formatDateTime(params.row.created_at)
    },
    { field: 'pl_type_name', headerName: 'Typ Powiadomienia', flex: 0.8 },
    { field: 'addressee', headerName: 'Adresat', flex: 0.4 },
    { field: 'title', headerName: 'Tytuł Powiadomienia', flex: 0.8 },
    { field: 'message_hidden', headerName: 'Wycinek Treści', flex: 1.2 },
    { field: 'sender', headerName: 'Użytkownik', flex: 0.4 }
  ];

  const handleSendOrderMail = async data => {
    const { error, loading } = await sendMailMutate(order.id, data);

    if (error) {
      toast.error('Nie udało się wysłać maila');
    }
  };

  return (
    <>
      <Card>
        <CardHeader title="Powiadomienia"></CardHeader>
        <CardContent>
          <form
            onSubmit={formik.handleSubmit}
            style={{ display: 'flex', flexDirection: 'row' }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Stack
                  direction="column"
                  justifyContent="space-between"
                  sx={{ widht: '50%' }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="left"
                    spacing={1}
                    flex="1 1 20%"
                  >
                    <Checkbox
                      id="automatic_notifications"
                      name="automatic_notifications"
                      checked={formik.values.automatic_notifications}
                      onChange={formik.handleChange}
                    />
                    <Typography variant="subtitle2">
                      Powiadomienia automatyczne
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="left"
                    spacing={1}
                    flex="1 1 20%"
                  >
                    <Checkbox
                      id="manual_notifications"
                      name="manual_notifications"
                      checked={formik.values.manual_notifications}
                      onChange={formik.handleChange}
                    />
                    <Typography variant="subtitle2">
                      Powiadomienia ręczne
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="left"
                    spacing={1}
                    flex="1 1 20%"
                  >
                    <Checkbox
                      id="automatic_advance_reminder_notifications"
                      name="automatic_advance_reminder_notifications"
                      checked={
                        formik.values.automatic_advance_reminder_notifications
                      }
                      onChange={formik.handleChange}
                    />
                    <Typography variant="subtitle2">
                      Powiadomienia o zapłacie zaliczki
                    </Typography>
                  </Stack>
                </Stack>{' '}
              </Grid>
              <Grid item xs={6}>
                {module != 'zielone_szkoly'
                  ? <EmailButton formik={formik}/>
                  : null
                }
              </Grid>
            </Grid>
          </form>
          <Box height={40} />
          <DataGridPro
            autoHeight
            rows={order.notifications}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 25]}
            pagination
            components={{ Toolbar: GridToolbar }}
            localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
          />
        </CardContent>
      </Card>
    </>
  );
};

export default Noitfications;
